// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2834":"d85538c80c6fa791","6215":"f8123232af532825","7361":"c611136ad6bd16cb","9641":"2b18248cc2aa7867"}[chunkId] + ".js";
};